import PropTypes from 'prop-types';
import React from 'react';

const ModalComponent = () => {
	return <></>;
};

ModalComponent.propTypes = {
	content: PropTypes.node,
	contentProps: PropTypes.object,
	shouldCloseOnEsc: PropTypes.bool,
	isOpen: PropTypes.bool,
	closeButton: PropTypes.bool,
	title: PropTypes.string,
	customClassName: PropTypes.string,
};

export default ModalComponent;
